import { Box, Chip, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { formatEuro } from "e.sic-platform.webclient/src/services/shop/formatEuro";

export interface ICoinProps {
  style?: any;
  text?: string;
  /** Amount in euro-cents (what the API sends for prices and balance). */
  amount?: number;
  withBorder?: boolean;
  color?: any;
}

// Shows a money amount in €. Kept under its old name so callers didn't change when the
// platform moved from credits to euros.
export const Coin = observer(function Coin(props: ICoinProps) {
  const chipStyle = useMemo(() => {
    const style = {
      p: 1,
      borderRadius: 1,
      borderWidth: 2,
      borderStyle: "style",
    };
    return props.withBorder ? style : { ...style, border: "none" };
  }, [props.withBorder]);

  const Amount = () => {
    return (
      <Box display="flex" flexDirection="row" alignItems="center">
        <Typography variant="body1" fontWeight="bold" sx={{ mr: 1, whiteSpace: "nowrap" }}>
          {props.amount != null ? formatEuro(props.amount) : "€"}
        </Typography>
      </Box>
    );
  };

  if (props.text)
    return (
      <Chip
        color={props.color ? props.color : "primary"}
        variant="outlined"
        deleteIcon={<Amount />}
        onDelete={() => {}}
        label={
          <Typography variant="body1" fontWeight="bold">
            {props.text}
          </Typography>
        }
        sx={chipStyle}
        size="medium"
      />
    );

  return <Amount />;
});
